var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCross(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.713.814l-8.16 8.161L3.39.815.918 3.286l8.161 8.161L.918 19.61l2.473 2.473 8.161-8.161 8.161 8.16 2.473-2.473-8.16-8.16 8.16-8.162L19.713.814z",
    fill: "currentColor"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjMgMjMiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0xOS43MTMzIDAuODE0MjA5TDExLjU1MjIgOC45NzUzTDMuMzkxMDkgMC44MTQyMDlMMC45MTc5NjkgMy4yODczM0w5LjA3OTA3IDExLjQ0ODRMMC45MTc5NjkgMTkuNjA5NUwzLjM5MTA5IDIyLjA4MjZMMTEuNTUyMiAxMy45MjE2TDE5LjcxMzMgMjIuMDgyNkwyMi4xODY0IDE5LjYwOTVMMTQuMDI1MyAxMS40NDg0TDIyLjE4NjQgMy4yODczM0wxOS43MTMzIDAuODE0MjA5WiIgZmlsbD0iY3VycmVudENvbG9yIi8+Cjwvc3ZnPgo=";
export { SvgCross as ReactComponent };